


import React, { useState, useEffect, useRef } from "react";
import { IoClose, IoAdd } from "react-icons/io5"; 

const MultiSelectDropdown = ({ options = [], value = [], onChange , onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [castOptions, setCastOptions] = useState([]);
  const [directorOptions, setDirectorOptions] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingCreateValue, setPendingCreateValue] = useState("");
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  //new part for tags starts


    // const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (onSearch) {
      const delay = setTimeout(() => {
        onSearch(searchTerm); // parent fetches filtered tags
      }, 300); // debounce
      return () => clearTimeout(delay);
    }
  }, [searchTerm, onSearch]);

  //new part for tags ends

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const getComparableValue = (obj) => {
    if (!obj) return "";
    return typeof obj === "object" ? obj.value : obj;
  };
  

  const removeOption = (option) => {
    const updated = value.filter(
      (item) => getComparableValue(item) !== getComparableValue(option)
    );
    onChange(updated);
  };


  const handleOptionClick = (option) => {
  const comparableOption = typeof option === "object" ? option.value : option;
  const alreadySelected = value.some(
    (item) =>
      (typeof item === "object" ? item.value : item) === comparableOption
  );
  if (!alreadySelected) {
    // Normalize to object { label, value }
    const newOption = typeof option === "object" ? option : { label: option, value: option };
    const updated = [...value, newOption];
    onChange(updated);
    setSearchTerm(""); // reset search
  }
};


  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const filteredOptions = options.filter((option) => {
    const label = typeof option === "object" ? option.label : String(option);
    const alreadySelected = value.some(
      (selected) => getComparableValue(selected) === getComparableValue(option)
    );
    return (
      !alreadySelected &&
      label.toLowerCase().includes(searchTerm.toLowerCase().trim())
    );
  });

  return (
    <div
      className="relative inline-block w-full text-sm mt-1"
      ref={dropdownRef}
    >
      {/* Selected Chips */}
      <div
        className={`border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-[#161b22] cursor-pointer`}
        onClick={toggleDropdown}
      >
        {value.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {value.map((option, index) => (
              <div
                key={getComparableValue(option)}
                className="bg-gray-200 dark:bg-blue-900/30 text-gray-600 dark:text-[#e6edf3] font-semibold p-1 px-3 text-xs rounded-sm flex items-center space-x-1 hover:bg-gray-300 dark:hover:bg-blue-800/40 hover:text-black dark:hover:text-white"
              >
                <span>
                  {typeof option === "object" ? option.label : String(option)}
                </span>
                <button
                  className="text-red-500 hover:text-red-700"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeOption(option);
                  }}
                >
                  <IoClose />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <span className="text-gray-400 dark:text-gray-500">Select options</span>
        )}
      </div>

      {/* Dropdown & Search */}
      {isOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white dark:bg-[#161b22] border border-gray-300 dark:border-gray-600 rounded-md shadow-lg">
          <div className="p-2 border-b border-gray-200 dark:border-gray-600">
            <input
              ref={inputRef}
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search..."
              className="w-full border border-gray-200 dark:border-gray-600 rounded-md px-2 py-1 text-sm focus:outline-none bg-white dark:bg-[#0d1117] text-gray-900 dark:text-[#e6edf3] placeholder-gray-400 dark:placeholder-gray-500"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();

                  if (filteredOptions.length > 0) {
                    handleOptionClick(filteredOptions[0]);
                  }
                }
              }}
            />
          </div>

          <ul className="max-h-40 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <li
                  key={getComparableValue(option)}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 text-xs font-medium cursor-pointer text-gray-800 dark:text-[#e6edf3] hover:bg-gray-100 dark:hover:bg-blue-900/20 transition-all"
                >
                  {typeof option === "object" ? option.label : String(option)}
                </li>
              ))
            ) : (
              <li
                className="px-4 py-2 text-xs cursor-pointer hover:bg-gray-100 dark:hover:bg-blue-900/20 transition-all flex items-center justify-between"
                onClick={() => {
                  if (searchTerm.trim()) {
                    setPendingCreateValue(searchTerm.trim());
                    setShowConfirm(true);
                  }
                }}
              >
                <span className="text-gray-600 dark:text-[#e6edf3] flex items-center gap-2">
                  <IoAdd size={16} />
                  Create "{searchTerm.trim() || '...'}"
                </span>
              </li>
            )}
          </ul>
        </div>
      )}

      {showConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowConfirm(false)}
          />
          <div className="relative z-10 bg-white dark:bg-[#161b22] p-6 rounded-2xl max-w-sm w-full border border-gray-200 dark:border-gray-600 shadow-2xl">
            <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-[#e6edf3]">Confirm Create</h2>
            <p className="mb-6 text-gray-600 dark:text-gray-400">
              Are you sure you want to add "<strong>{pendingCreateValue}</strong>"?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const newOption = { label: pendingCreateValue, value: pendingCreateValue };
                  const updated = [...value, newOption];
                  onChange(updated);
                  setSearchTerm("");
                  setIsOpen(false);
                  setShowConfirm(false);
                  setPendingCreateValue("");
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Yes, Add It
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;